import ShoppingProduct from "components/ShoppingProduct";
import "../../../components/DepositTab.css";

function DepositMethod({ method }) {
  return (
    <div className="payment-method-item">
      <img src={`/assets/images/payments/${method}.png`} alt={method} />
    </div>
  );
}

export default function DepositTab() {
  return (
    <div id="deposit-tab" className="deposit-container">
      <div className="payment-methods-section">
        <div className="payment-methods-title">
          <i className="ti ti-credit-card"></i>
          <h5>Payment methods</h5>
        </div>
        <div className="payment-method-grid">
          <DepositMethod method="stripe" />
        </div>
      </div>

      <div className="packages-section">
        <div className="deposit-header">
          <h3>Choose your package</h3>
          <p className="deposit-info-text">
            After successful payment, the credits should arrive immediately.
            Please wait a minute and refresh the page.
          </p>
          <p className="deposit-info-text">
            If you have any questions or concerns, please{" "}
            <a href="support.html">contact us</a>.
          </p>
        </div>

        <div className="packages-grid">
          <ShoppingProduct
            category="Credits"
            title="100 CREDITS for 1.00$ CAD"
            description="You can add more credits in the checkout page"
            buttonText="Buy Now"
            qty={100}
          />
          <ShoppingProduct
            category="Credits"
            title="500 CREDITS for 5.00$ CAD"
            description="You can add more credits in the checkout page"
            buttonText="Buy Now"
            qty={500}
          />
        </div>
      </div>
    </div>
  );
}
